<template>
  <artmisads-modal v-model:open="open" :maskClosable="false" title="Upload Examples" :footer="null" width="720px" @cancel="handleClose">
    <a-spin :spinning="loading">
    <div class="content">
      <div v-if="currentStep === 1">
        <div class="content-title">
          We recommend you uploading examples like this
        </div>
        <div class="image-container">
          <a-image :src="require('@/assets/images/uploadExample.png')" alt=""  :placeholder="true" />
        </div>
        <div class="content-title">
          Upload file
        </div>
   
        <div 
          :class="{ 'drag-over': isDragOver }"
          @dragenter="handleDragEnter"
          @dragleave="handleDragLeave"
          @dragover="handleDragOver"
          @drop="handleDrop">
          <a-upload name="avatar" list-type="picture-card" :show-upload-list="false" accept=".jpg,.png,.jpeg,.gif"
            :before-upload="beforeUpload" @change="handleUploadChange" :custom-request="customUpload"
            @remove="handleRemove">

          <p class="ant-upload-drag-icon">
            <inbox-outlined></inbox-outlined>
          </p>
          <svg class="icon shangchuan2" aria-hidden="true">
            <use xlink:href="#icon-a-shangchuan3"></use>
          </svg>
         <p class="text-style"> Drag and Drop file here or <span class="choose-file">Choose file</span></p>
          </a-upload>
        </div>
        <div class="upload-botttom-text">
          <span> Maximum of 3 images. Available file formats:PNG、JPG、GIF</span>
          <span>Maximum size: 25MB</span>
        </div>
        <div class="preview-container" v-if="exampleFiles.length > 0">
          <div class="preview-item" v-for="item in exampleFiles" :key="item.originalFileName">
            <a-image :src="item.url" alt=""  :placeholder="true" />
            <div class="close" @click="handleRemoveItem(item)">
              <Icon name="close-cu" class="close-icon"></Icon>
            </div>
          </div>
        </div>
      </div>
      <div v-if="currentStep === 2">
        <div class="content-title">
          Preview
        </div>
        <div class="preview-container2" v-if="exampleFiles.length > 0">
          <div class="preview-item2" v-for="(item, index) in exampleFiles" :key="item.originalFileName">
            <div class="image-wrapper" @mouseenter="handleMouseEnter($event, item, index)"  >
              <a-image :preview="false" :src="item.url" alt=""  :placeholder="true" />
              <!-- <canvas 
                :ref="el => setIndicatorCanvasRef(el, index)"
                class="indicator-canvas"
                width="56"
                height="56"
                :style="{ display: showMagnifier && currentImageIndex === index ? 'block' : 'none' }"
              ></canvas> -->
            </div>
          </div>
        </div>
         <div class="canvas-container" >
          <a-image :src="currentImage" alt="" class="canvas-image"  :placeholder="true" />
           <!-- <canvas 
               v-if="showMagnifier"
               ref="magnifierCanvas"
               width="750"
               height="400"
               class="magnifier-canvas"
            ></canvas> -->
          </div>
      </div>
      <div class="footer">
        <div class="footer-cancel" @click="handleClose" v-if="currentStep === 1">
          Cancel
        </div>
        <div class="footer-cancel" @click="handleReturn" v-if="currentStep === 2">
          Return
        </div>
        <artmisads-button v-if="currentStep === 1" :disabled="exampleFiles.length === 0" :loading="loading"
          type="primary" @click="handleNext">
          Next
        </artmisads-button>
        <artmisads-button v-if="currentStep === 2" :disabled="exampleFiles.length === 0" :loading="loading"
          type="primary" @click="handleUpload">
          Upload
        </artmisads-button>
      </div>
    </div>
    </a-spin>
  </artmisads-modal>
</template>
<script setup>
import { ref, defineExpose, nextTick,defineEmits } from 'vue'
import adminApi from '~/server/seller/admin'
import { message } from 'ant-design-vue'
import Icon from "@/components/Icon.vue"
const emit = defineEmits(['upload'])
const uploadImageUrl = ref({})
const currentStep = ref(1)
const open = ref(false)
const props = defineProps({
  exampleFiles: {
    type: Array,
    default: () => []
  }
})
const handleNext = () => {
  currentStep.value++
  if(exampleFiles.value.length>0){
    currentImage.value=exampleFiles.value[0].url
  }
}
const handleClose = () => {
  open.value = false
}
const handleReturn = () => {
  currentStep.value--
}
const exampleFiles = ref([

])
const loading = ref(false)

// Canvas局部查看相关变量
const showMagnifier = ref(false)
const magnifierCanvas = ref(null)
const indicatorCanvasRefs = ref([])
const currentImage = ref('')
const currentImageIndex = ref(-1)
const isDragOver = ref(false)
const canvasWidth = 750 // canvas宽度
const canvasHeight = 400 // canvas高度
const zoomFactor = 2 // 放大倍数
const show = () => {
  open.value = true
  currentStep.value = 1
  exampleFiles.value =JSON.parse(JSON.stringify(props.exampleFiles))
}
function getBase64 (img, callback) {
  const reader = new FileReader()

  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
const handleChange = (info) => {
  console.log(info, 'info')
}
const handleRemove = (file) => {
  // console.log(file, 'file')
  exampleFiles.value = exampleFiles.value.filter(item => item.originalFileName !== file.name)
  // console.log(exampleFiles.value,'exampleFiles.value')
}
const handleRemoveItem = (itemFile) => {
  exampleFiles.value = exampleFiles.value.filter(item => item.url !== itemFile.url)
}
// 自定义上传处理
const customUpload = (options) => {
  const { file, onSuccess, onError, onProgress } = options
  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif']
  const isValidExtension = allowedExtensions.some(ext =>
    file.name.toLowerCase().endsWith(ext)
  )
  loading.value = true
  if (isValidExtension) {
    const data = {}

    if (file) {
      data.file = file
    } else {
      data.url = encodeURIComponent(uploadImageUrl.value)
    }
    // 模拟上传进度
    adminApi.uploadImg(data).then((res) => {

      onSuccess({
        url: URL.createObjectURL(file),
        name: file.name,
        status: 'done'
      })
      exampleFiles.value.push({
        originalFileName: file.name,
        url: res.data.url
      })
    }).catch(e => {
      console.log(e)
    }).finally(() => {
      loading.value = false
    })
  }
}
const beforeUpload = (file) => {
  const allowedTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
  ]
  if (exampleFiles.value.length >= 3) {
    message.error('You can upload up to three images.')
    return false
  }
  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif']

  const isValidType = allowedTypes.includes(file.type)
  const isValidExtension = allowedExtensions.some(ext =>
    file.name.toLowerCase().endsWith(ext)
  )

  if (!isValidType && !isValidExtension) {
    message.error('Only  jpg, png, jpeg, gif files are supported') // 英文  只支持上传 zip、jpg、png、jpeg、pdf、rar 格式的文件
    return false
  }

  const isLt10M = file.size / 1024 / 1024 < 25
  if (!isLt10M) {
    message.error('File size cannot exceed 25MB!')
    return false
  }

  return true
}
// 处理上传状态变化
const handleUploadChange = (info) => {
  const { file, fileList } = info

  if (file.status === 'done') {
    getBase64(file.originFileObj, (base64Url) => {
      uploadImageUrl.value = base64Url
    })
  }
  // 如果上传失败，清除错误状态
  if (file.status === 'error') {
    message.error('Upload failed. Please try again.')

  }

}

// 拖拽事件处理方法
const handleDragEnter = (e) => {
  e.preventDefault()
  e.stopPropagation()
 
  isDragOver.value = true
}

const handleDragLeave = (e) => {
  e.preventDefault()
  e.stopPropagation()
  // 只有当离开整个拖拽区域时才设置为false
  if (!e.currentTarget.contains(e.relatedTarget)) {
   
    isDragOver.value = false
  }
}

const handleDragOver = (e) => {
  e.preventDefault()
  e.stopPropagation()
}

const handleDrop = (e) => {
  e.preventDefault()
  e.stopPropagation()
 
  isDragOver.value = false
 
}

// Canvas局部查看相关方法
const setIndicatorCanvasRef = (el, index) => {
  if (el) {
    indicatorCanvasRefs.value[index] = el
  }
}

const handleMouseEnter = async (event, item, index) => {

  showMagnifier.value = true
  currentImage.value = item.url
  currentImageIndex.value = index
  
  
  // await nextTick()
  // const canvas = magnifierCanvas.value
  // if (canvas) {
  //   canvas.width = canvasWidth
  //   canvas.height = canvasHeight
  
  // }
}

const handleMouseLeave = () => {
  showMagnifier.value = false
  currentImage.value = null
  currentImageIndex.value = -1
}

const handleMouseMove = (event, item, index) => {
  if (!showMagnifier.value || !currentImage.value || currentImageIndex.value !== index) return
  
  const canvas = magnifierCanvas.value
  if (!canvas) {
   
    return
  }
  
  const rect = event.currentTarget.getBoundingClientRect()
  const x = event.clientX - rect.left
  const y = event.clientY - rect.top
  
  // 绘制放大后的图片局部
  drawMagnifiedImage(canvas, currentImage.value.url, x, y)
  
  // 绘制小图片上的指示器
  drawSmallImageIndicator(index, x, y)
}
const handleUpload=()=>{

  handleClose()
  emit('upload', exampleFiles.value)
}
const drawMagnifiedImage = (canvas, imageUrl, mouseX, mouseY) => {
 
  const ctx = canvas.getContext('2d')
  const img = new Image()
  
  img.onload = () => {
   
    // 清空canvas
    ctx.clearRect(0, 0, canvasWidth, canvasHeight)
    
    // 计算图片在canvas中的显示尺寸（保持宽高比）
    const imgAspectRatio = img.width / img.height
    const canvasAspectRatio = canvasWidth / canvasHeight
    
    let displayWidth, displayHeight, offsetX, offsetY
    
    if (imgAspectRatio > canvasAspectRatio) {
      // 图片更宽，以宽度为准
      displayWidth = canvasWidth
      displayHeight = canvasWidth / imgAspectRatio
      offsetX = 0
      offsetY = (canvasHeight - displayHeight) / 2
    } else {
      // 图片更高，以高度为准
      displayHeight = canvasHeight
      displayWidth = canvasHeight * imgAspectRatio
      offsetX = (canvasWidth - displayWidth) / 2
      offsetY = 0
    }
    
    // 计算源图片的尺寸
    const sourceWidth = 56 // 原始图片显示宽度
    const sourceHeight = 56 // 原始图片显示高度
    
    // 判断鼠标在哪个1/4区域
    const quarterWidth = sourceWidth / 2
    const quarterHeight = sourceHeight / 2
    
    let quarterIndex = 0
    if (mouseX < quarterWidth && mouseY < quarterHeight) {
      quarterIndex = 0 // 左上
    } else if (mouseX >= quarterWidth && mouseY < quarterHeight) {
      quarterIndex = 1 // 右上
    } else if (mouseX < quarterWidth && mouseY >= quarterHeight) {
      quarterIndex = 2 // 左下
    } else {
      quarterIndex = 3 // 右下
    }
   
    // 计算源图片中对应1/4区域的坐标
    const sourceQuarterX = (quarterIndex % 2) * (img.width / 2)
    const sourceQuarterY = Math.floor(quarterIndex / 2) * (img.height / 2)
    const sourceQuarterWidth = img.width / 2
    const sourceQuarterHeight = img.height / 2
    
    // 绘制选中的1/4区域，放大到整个canvas
    ctx.drawImage(
      img,
      sourceQuarterX, sourceQuarterY, sourceQuarterWidth, sourceQuarterHeight, // 源图片1/4区域
      offsetX, offsetY, displayWidth, displayHeight // 目标canvas区域
    )
    
    // 添加边框
    ctx.strokeStyle = '#E8E5ED'
    ctx.lineWidth = 2
    ctx.strokeRect(offsetX, offsetY, displayWidth, displayHeight)
  }
  
  img.onerror = (e) => {
    console.error('Image load error:', e)
  }
  
  img.src = imageUrl
}

// 绘制小图片上的1/4区域指示器
const drawSmallImageIndicator = (index, mouseX, mouseY) => {
  const indicatorCanvas = indicatorCanvasRefs.value[index]
  if (!indicatorCanvas) return
  
  const ctx = indicatorCanvas.getContext('2d')
  
  // 清空canvas
  ctx.clearRect(0, 0, 56, 56)
  
  // 计算1/4区域
  const quarterWidth = 56 / 2
  const quarterHeight = 56 / 2
  
  let quarterIndex = 0
  if (mouseX < quarterWidth && mouseY < quarterHeight) {
    quarterIndex = 0 // 左上
  } else if (mouseX >= quarterWidth && mouseY < quarterHeight) {
    quarterIndex = 1 // 右上
  } else if (mouseX < quarterWidth && mouseY >= quarterHeight) {
    quarterIndex = 2 // 左下
  } else {
    quarterIndex = 3 // 右下
  }
  
  // 计算1/4区域的位置
  const quarterX = (quarterIndex % 2) * quarterWidth
  const quarterY = Math.floor(quarterIndex / 2) * quarterHeight
  
  // 绘制红色边框正方形
  ctx.strokeStyle = '#ff0000'
  ctx.lineWidth = 2
  ctx.strokeRect(quarterX, quarterY, quarterWidth, quarterHeight)
  
  // 添加半透明填充
  ctx.fillStyle = 'rgba(255, 0, 0, 0.2)'
  ctx.fillRect(quarterX, quarterY, quarterWidth, quarterHeight)
}

// 绘制1/4区域指示器（用于大canvas，现在不需要了）
const drawQuarterIndicator = (ctx, mouseX, mouseY, quarterWidth, quarterHeight, quarterIndex) => {
  // 计算1/4区域的位置
  const quarterX = (quarterIndex % 2) * quarterWidth
  const quarterY = Math.floor(quarterIndex / 2) * quarterHeight
  
  // 绘制红色边框正方形
  ctx.strokeStyle = '#ff0000'
  ctx.lineWidth = 3
  ctx.strokeRect(quarterX, quarterY, quarterWidth, quarterHeight)
  
  // 添加半透明填充
  ctx.fillStyle = 'rgba(255, 0, 0, 0.1)'
  ctx.fillRect(quarterX, quarterY, quarterWidth, quarterHeight)
}

defineExpose({
  show
})
</script>
<style lang="less" scoped>
.text-style{
  font-size: 14px;
}

// 拖拽容器样式
.drag-over {
  :deep(.ant-upload.ant-upload-select) {
    background: #f8f5ff !important;
    border: 2px dashed #6C3DF2 !important;
    transform: scale(1.02);
    transition: all 0.2s ease;
    
  
  }
}

:deep(.ant-upload-wrapper) {
  margin-top: 8px;

  .ant-upload.ant-upload-select {
    width: 100%;
    height: 64px;
    color: var(--dark-2);
    background: var(--big-bg-1);
    border: 2px dashed var(--border-1);
    border-radius: 8px;
    font-size: var(--font-size-h-l);

    &:hover {
      background: #f8f5ff;
      border: 2px dashed #6C3DF2;
      transform: scale(1.02);
      transition: all 0.2s ease;
      
     
    }

    svg {
      width: 32px;
      height: 32px;
      fill: var(--dark-2);
      margin-right: 16px;
    }
  }
}

:deep(.ant-upload-wrapper) {
  margin-top: 16px;

  .ant-upload.ant-upload-select {
    width: 100%;
    height: 60px;
    color: var(--dark-2);
    background: var(--big-bg-1);
    border: 1px dashed var(--border-1);
    border-radius: 8px;
    font-size: var(--font-size-h-l);
    font-weight: 500;

    &:hover {
      background: var(--bg-gray-2);
      border: 2px dashed var(--bg-gray-7);
    }

    svg {
      width: 24px;
      height: 24px;
      fill: var(--dark-2);
      margin-right: 8px;
    }
  }
}
.choose-file{
  color: #6C3DF2;
  padding-left: 5px;
 text-decoration-line: underline;
}
.content {
  .preview-container2{
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin: 16px 0;
    .preview-item2{
      width: 56px;
      height: 56px;
      border-radius: 8px;
      border: 1px solid #E8E5ED;
      
      .image-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        cursor: pointer;
        border-radius: 8px;
        overflow: hidden;
        background-color: #E8E5ED;
        border: 1px solid #E8E5ED;
        :deep(img){
          object-fit: contain;
          max-height: 56px;
        }
       
      }
    }
  }
  
  .canvas-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    display: flex;
    align-items: center;
    overflow: hidden;
    width: 100%;
    height: 400px;
    height: 350px;
    border-radius:  6px;
    border: 1px solid  #E8E5ED;
    background-color: #E8E5ED;
    // :deep(.canvas-image) {
    //   object-fit: contain !important;
    //   height: 350px !important;
    // }
    :deep( img) {
      object-fit: contain !important;
      max-height: 350px !important;
    }
    // .magnifier-canvas {
    //   border: 2px solid #E8E5ED;
    //   border-radius: 8px;
    //   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    //   background: white;
    // }
  }
  .preview-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin: 16px 0;

    .preview-item {
      position: relative;
      overflow: hidden;
      width: 120px;
      height: 120px;
      border-radius: 8px;
      border: 1px solid #E8E5ED;
      background-color: #E8E5ED;
      display: flex;
      align-items: center;
      justify-content: center;
      :deep(img){
        object-fit: contain;
       
        max-height: 120px !important;
      }
      .close {
        z-index: 10;
        position: absolute;
        top: 0;
        right: 0;
        width: 22px;
        height: 22px;
        border-radius: 0 0 0 8px;
        background-color: rgba(15, 6, 41, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .close-icon {
          width: 12px;
          height: 12px;
          color: #fff;
        }
      }
    }
  }

  .footer {
    border-top: 1px solid #E8E5ED;
    padding: 12px;
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    align-items: center;

    .footer-cancel {
      cursor: pointer;
      color: #0f0629;
      text-align: center;
      font-family: "Sora";
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      margin-right: 14px;
      letter-spacing: 0.4px;
      opacity: 0.7;
    }
  }

  .upload-botttom-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 12px 0;
    color: #0f062980;
    font-family: "Sora";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.3px;
    opacity: 0.7;
  }

  // padding: 16px 20px;
  background-color: #fff;

  .content-title {
    color: #0f0629;
    font-family: "Sora";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;

    letter-spacing: 0.4px;
    opacity: 0.9;
  }

  .image-container {
    border-radius: 6px;
    min-height: 300px;
    background-color: #f5f5f5;
    margin: 14px 0;
  }
}
</style>